<template>
  <v-card outlined class="po-product-entry-card">
    <v-card-text class="pa-3">
      <v-layout row align-center fill-height class="po-entry-row">
        <v-flex class="entry-product">
          <v-autocomplete
            v-model="selectedProduct"
            hide-no-data
            ref="productSearch"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            :search-input.sync="phoneSearch"
            :loading="loading"
            auto-select-first
            single-line
            hide-details
            clearable
            id="productSearch"
            :items="Products"
            item-text="name"
            return-object
            :label="$t('labels.searchProduct')"
          >
            <template slot="item" slot-scope="{ item }">
              <span>{{ item.name }}</span>
              <v-spacer></v-spacer>
              <v-chip
                v-if="item.trackInventory"
                :color="
                  item.trackSerialNumber ? 'light-primary' : 'teal darken-1'
                "
                dark
              >
                <v-avatar
                  left
                  class="light-blue darken-2"
                  v-if="item.trackSerialNumber"
                >
                  <v-icon small>mdi-barcode-scan</v-icon>
                </v-avatar>
                <v-avatar left v-else class="teal darken-3">
                  <v-icon small>mdi-package-variant-closed</v-icon>
                </v-avatar>
                <span>{{ item.balance }}</span>
              </v-chip>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex class="entry-name">
          <v-text-field
            @focus="$event.target.select()"
            label="Item Name"
            @keyup.enter="$refs.qty.focus"
            :disabled="lockProductName"
            v-model="name"
            outlined
            dense
            hide-details
            ref="itemName"
          ></v-text-field>
          
        </v-flex>
        <v-flex class="entry-quantity">
          <v-text-field
            class="centered-input"
            @focus="$event.target.select()"
            ref="qty"
            outlined
            dense
            hide-details
            label="Quantity"
            @keyup.enter="$refs.boxPrice.focus"
            v-model="qty"
          ></v-text-field>
        </v-flex>
        <v-flex class="entry-price">
          <v-text-field
            class="right-input"
            ref="boxPrice"
            @focus="$event.target.select()"
            label="Price"
            v-model="price"
            outlined
            @keyup.enter="submit"
            dense
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="entry-total">
          <v-text-field
            disabled
            class="right-input"
            ref="extAmount"
            outlined
            dense
            hide-details
            @focus="$event.target.select()"
            v-model="total"
            label="Ext Amount"
          ></v-text-field>
        </v-flex>
        <v-flex d-flex class="entry-add">
          <v-btn color="primary" depressed rounded height="40" ref="addbutton" @click="submit" :disabled="!selectedProduct">
            <v-icon left small>mdi-plus</v-icon>
            Add
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import productService from "@/modules/Product/service";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  data() {
    return {
      loading: false,
      Products: [],
      phoneSearch: null,
      selectedProduct: null,
      name: null,
      disabledQty: false,
      qty: 1,
      price: 0,
      total: 0,
    };
  },
  created() {
    this.getProduct();
    this.emptyEntryBar();
  },
  computed: {
    ...mapGetters("invoice", ["Invoice", "InvoiceDetails"]),
    ...mapGetters("global", ["currentBusiness"]),
    lockProductName() {
      if (!this.currentBusiness.metadata.hasOwnProperty("lockProductName")) {
        return true;
      } else if (this.currentBusiness.metadata.lockProductName) {
        return true;
      }
      return false;
    },
  },
  watch: {
    phoneSearch: _.debounce(function (val) {
      if (val && val.length > 2) {
        this.getProduct();
      }
    }, 300),
    qty() {
      this.total = this.qty * this.price;
    },
    price(val) {
      this.total = val * this.qty;
    },
    selectedProduct(val) {
      if (val) {
        this.setProduct(val);
      }
    },
  },
  methods: {
    setProduct(product) {
      if (product) {
        this.price = product.price;
        this.total = product.price * this.qty;
        this.name = product.name;

        this.$nextTick(() => {
          this.$refs.itemName.focus();
        });
      }
    },
    emptyEntryBar() {
      this.name = null;
      this.qty = 1;
      this.total = 0;
      this.price = 0;
      this.selectedProduct = null;
      setTimeout(() => {
        this.$refs.productSearch.focus();
      }, 300);
    },
    submit() {
      if (!this.selectedProduct) return false;
      this.selectedProduct.Bar = {
        name: this.name,
        qty: this.qty,
        price: this.price,
      };

      this.$emit("submit", this.selectedProduct);
      this.emptyEntryBar();
    },
    getProduct() {
      this.loading = true;
      return productService
        .getAll({ search: this.phoneSearch, hideParent: true })
        .then((result) => {
          this.Products = result.data;
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.po-product-entry-card{border-radius:20px;background:#fff;overflow:hidden}.po-entry-row{display:flex;gap:8px;margin:0!important;flex-wrap:wrap}.po-entry-row>.flex{padding:0!important}.entry-product{flex:2 1 240px}.entry-name{flex:1.8 1 210px}.entry-quantity{flex:0 1 110px}.entry-price,.entry-total{flex:1 1 150px}.entry-add{flex:0 0 auto}.entry-add .v-btn{min-width:86px}::v-deep .v-input--is-focused .v-input__slot{box-shadow:0 0 0 2px rgba(37,99,235,.08)}@media(min-width:1100px){.po-entry-row{flex-wrap:nowrap}}@media(max-width:600px){.po-entry-row>.flex{flex:1 1 100%}.entry-quantity,.entry-price,.entry-total{flex:1 1 calc(33.333% - 6px)}.entry-add .v-btn{width:100%}}
</style>
